/**
 * Responsive Hook
 * Detects screen size for responsive layouts
 */

import { useState, useEffect } from 'react';
import { BREAKPOINTS } from '../constants';

/**
 * Hook to detect device type based on screen width
 * @returns {{ isMobile: boolean, isTablet: boolean, isDesktop: boolean }}
 */
export const useResponsive = () => {
  const [screenSize, setScreenSize] = useState({
    isMobile: window.innerWidth < BREAKPOINTS.MOBILE,
    isTablet: window.innerWidth >= BREAKPOINTS.MOBILE && window.innerWidth < BREAKPOINTS.TABLET,
    isDesktop: window.innerWidth >= BREAKPOINTS.TABLET,
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setScreenSize({
        isMobile: width < BREAKPOINTS.MOBILE,
        isTablet: width >= BREAKPOINTS.MOBILE && width < BREAKPOINTS.TABLET,
        isDesktop: width >= BREAKPOINTS.TABLET,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screenSize;
};

export default useResponsive;

